import type { CotizaTodasResponse } from '@/types/quote.types';
import { requestCotizaTodas, type CotizaTodasOptions } from './quoteApi';

export {
  getBrands,
  getModels,
  getVehicleTypes,
  getPostalCodes,
  getVersions,
  getQuote,
  generateCotizacionAutosDetalle,
} from './quoteApi';
export type { PostalCodeResult } from './quoteApi';
export { executeForCRUD } from './frontBack';
export type { IRequestParams, ExecuteForCRUDResponse } from './frontBack';

/** `cotizaTodas` options; omitted fields default to cash payment (`C`), package `1` and Qualitas. */
export type CotizaTodasRequest = Pick<CotizaTodasOptions, 'idCotizacion' | 'postalCode'> &
  Partial<Pick<CotizaTodasOptions, 'formaPago' | 'paquete' | 'company'>>;

/**
 * Obtiene el detalle completo de la cotización con coberturas y primas
 * para una compañía específica (Qualitas o Ana).
 * @returns Respuesta con detalles de coberturas, primas y pagos
 */
export const cotizaTodas = ({
  idCotizacion,
  formaPago = 'C',
  paquete = '1',
  company = 'QUALITAS',
  postalCode,
}: CotizaTodasRequest): Promise<CotizaTodasResponse> =>
  requestCotizaTodas({ idCotizacion, formaPago, paquete, company, postalCode });
